import { useGSAP } from "@gsap/react"
import { animateWithGsap } from "../../utils/animations";

const SectionCard = ({ title, subtitle, children, className = "" }) => {
  useGSAP(() => {
    animateWithGsap(".g-title", { 
      y: 0,
      opacity: 1,
      ease: "power2.inOut",
      duration: 1.5,
      stagger: 0.5,
    })
  }, [])
  return(
  <div
    className={`bg-white p-6 rounded-2xl shadow-lg border border-gray-100 ${className}`}
  >
    <div className="mb-6 pb-4 border-b border-gray-100">
      <h3 className="text-xl font-bold text-secondary-800 g-title opacity-0 translate-y-[100px]">{title}</h3>
      {subtitle && <p className="text-secondary-600 mt-1 g-title opacity-0 translate-y-[100px]">{subtitle}</p>}
    </div>
    {children}
  </div>
)};

export default SectionCard;